<div class="flex-fill d-flex flex-column dx-card">
  <div class="d-flex flex-column flex-fill responsive-paddings">
    <dx-data-grid
      #dataGrid
      keyExpr="id"
      class="flex-fill d-flex flex-column"
      height="100px"
      [dataSource]="dumpsterInventoryLocations"
      [showBorders]="true"
      [showRowLines]="true"
      [rowAlternationEnabled]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onRowDblClick)="rowDoubleClick($event)"
      >
      <dxi-data-grid-column dataField="size" caption="Type" width="80"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="dumpsterNumber" caption="No." width="50"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="dumpsterBarcode" caption="Barcode" width="150"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="createdDate" caption="Created" width="100"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="currentJob" caption="CurrentJob" width="400"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="recentJobsHtml" caption="Recent Jobs" width="400" cellTemplate="htmlTemplate"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="notes" width="250"></dxi-data-grid-column>
      <dxi-data-grid-column dataField="maintenanceLinks" caption="Maintenance" width="250" cellTemplate="maintenanceLinkTemplate"></dxi-data-grid-column>
      <dxi-data-grid-column></dxi-data-grid-column>

      <div *dxTemplate="let cell of 'maintenanceLinkTemplate'">
        @for (maintenanceLink of cell.data.maintenanceLinks; track maintenanceLink) {
          <div>
            <a [routerLink]="[]" (click)="editMaintenance(maintenanceLink.maintenance)">{{ maintenanceLink.html }}</a>
          </div>
        }
      </div>

      <div *dxTemplate="let cell of 'htmlTemplate'">
        <span [innerHTML]="cell.text"></span>
      </div>

      <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
      <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
      <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
      <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
      <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="dumpster-inventory-grid"></dxo-data-grid-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          class="btn btn-primary me-1 mb-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          [hidden]="!isDumpsterAdmin"
          >
          Open
        </button>
        <button class="btn btn-success me-2 mb-2" (click)="open()" [hidden]="!isDumpsterAdmin">Add</button>
        <button
          class="btn btn-danger me-4 mb-2"
          (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          [hidden]="!isDumpsterAdmin"
          >
          Delete
        </button>
        <button
          class="btn btn-primary me-2 mb-2"
          (click)="createMaintenance(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          [hidden]="!isDumpsterAdmin"
          >
          Log Maintenance
        </button>
        <button
          class="btn btn-primary me-2 mb-2"
          (click)="assignLocation(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          [hidden]="!isDumpsterAdmin"
          >
          Assign Location
        </button>
        <button
          class="btn btn-primary me-2 mb-2"
          (click)="addNote(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          [hidden]="!isDumpsterAdmin"
          >
          Add Note
        </button>
        <button
          class="btn btn-success mb-2"
          (click)="releaseDumpster()"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          [hidden]="!isDumpsterAdmin"
          >
          Release
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (dumpsterInventoryLocations) {
          <span class="me-3">
            <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
